const buildMessageDetails = data => {
  if (data?.thread_details?.length) {
    return data.thread_details.map(detail => ({
      isMessageDetail: true,
      name: "messageDetails",
      type: "messageDetailsView",
      data: detail
    }));
  }
};

export default buildMessageDetails;
